import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-template-edit-modal',
  templateUrl: './template-edit-modal.component.html',
  styleUrls: ['./template-edit-modal.component.scss']
})
export class TemplateEditModalComponent implements OnInit {
  @Input() templateName: string;
  @Input() templateType: string;
  @Input() content: string;
  templateForm: FormGroup;

  constructor(public modal: NgbActiveModal, private fb: FormBuilder) {}

  ngOnInit() {
    this.templateForm = this.fb.group({
      content: [this.content || '', Validators.required]
    });
  }

  onSave() {
    if (this.templateForm.valid) {
      this.modal.close({
        success: true,
        content: this.templateForm.value.content,
        templateType: this.templateType
      });
    }
  }

  onCancel() {
    this.modal.dismiss();
  }
}
